import { render } from "./customerDetails.vue?vue&type=template&id=a1541650&scoped=true&ts=true"
import script from "./customerDetails.vue?vue&type=script&lang=ts"
export * from "./customerDetails.vue?vue&type=script&lang=ts"

import "./customerDetails.vue?vue&type=style&index=0&id=a1541650&scoped=true&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1541650"]])

export default __exports__